<form [formGroup]="form" class="flex flex-col justify-center items-start w-full h-auto">
  <div class="flex justify-between items-center w-full pr-2 mb-2">
    <label
      #subtitleLabel
      for="item"
      [class.text-label]="enabled() && !showError()"
      [class.text-label-error]="showError()"
      [class.text-label-disabled]="!enabled()"
    >
      {{ configSignal().label }}
    </label>

    @if (showBlockerIcon()) {
      <app-lock-toggle
        [unlocked]="enabled()"
        (pressed)="toggleEnabled()"
      ></app-lock-toggle>
    }
  </div>

  <div
    #inbox
    class="w-full h-10 flex justify-center items-center px-2 py-1 rounded-sm shadow-lg border bg-white"
    [class.border-blue-700]="enabled() && !showError()"
    [class.border-error]="showError()"
    [class.border-gray-300]="!enabled()"
  >
    <select
      id="selected"
      formControlName="selected"
      [compareWith]="compareSelectValues"
      (blur)="onBlurSelect()"
      class="w-full h-full border-none outline-none focus:ring-0 rounded px-3 bg-transparent appearance-auto cursor-pointer"
      [class.bg-gray-100]="!enabled()"
      [class.text-gray-400]="!enabled()"
      [class.text-gray-900]="enabled()"
    >
      <option [ngValue]="''" disabled hidden class="text-gray-500">{{ configSignal().placeholder }}</option>
      @for (opt of optionsList(); track opt.value) {
        <option [ngValue]="opt.value" class="text-gray-900">
          {{ opt.label }}
        </option>
      }
    </select>
  </div>

  @if (showError()) {
    <div class="text-red-500 text-[10px] mt-1">
      {{ configSignal().textError }}
    </div>
  }
</form>
